import { httpsCallable } from 'firebase/functions';

import { getFirebaseFunctions } from '@/lib/firebase/functions';
import type { AskProposalQuestionRequest, AskProposalQuestionResponse } from '@/types/backend-contracts';
import { buildAskProposalQuestionQueryKey } from '@/lib/query-cache/query-keys';
import { resolveBrowserQueryCache, type BrowserQueryCache } from '@/lib/query-cache/query-cache';

export async function askProposalQuestion(
  request: AskProposalQuestionRequest,
  options?: { cache?: BrowserQueryCache },
): Promise<AskProposalQuestionResponse> {
  const cache = resolveBrowserQueryCache(options?.cache);

  const result = await cache.read(
    buildAskProposalQuestionQueryKey(request),
    async () => {
      const callable = httpsCallable<AskProposalQuestionRequest, AskProposalQuestionResponse>(
        getFirebaseFunctions(),
        'askProposalQuestion',
      );

      const response = await callable(request);
      return response.data;
    },
    {
      staleTimeMs: 10 * 60 * 1000,
      cacheTimeMs: 60 * 60 * 1000,
      tags: ['question-answer'],
    },
  );

  return result.value;
}
